import rems from './utils/rems';

const dimensions = {
  headerHeight: '94px',
  headerHeightMobile: '66px',
};

export default {
  spacingXs: rems(4),
  spacingSm: rems(8),
  spacingMd: rems(16),
  spacingLg: rems(24),
  spacingXl: rems(32),
  spacingXxl: rems(48),

  ...dimensions,
};
